(function(){
  var isMobile = window.innerWidth <= 768;
  var obs = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(e.isIntersecting){
        e.target.classList.add('visible');
        obs.unobserve(e.target);
      }
    });
  },{threshold: isMobile ? 0.08 : 0.12, rootMargin:'0px 0px -30px 0px'});
  document.querySelectorAll('.reveal').forEach(function(el){ obs.observe(el) });
})();
(function(){var pipeline=document.getElementById('stagePipeline');if(!pipeline)return;var items=pipeline.querySelectorAll('.stage-item');var connectors=pipeline.querySelectorAll('.stage-connector');var isMobile=window.innerWidth<=768;var stageDelay=isMobile?400:600;var activated=false;var obs=new IntersectionObserver(function(entries){if(entries[0].isIntersecting&&!activated){activated=true;items.forEach(function(item,i){setTimeout(function(){item.classList.add('active');var circle=item.querySelector('.stage-num svg circle');if(circle) circle.style.strokeDashoffset='0';if(connectors[i]){setTimeout(function(){connectors[i].classList.add('animated');},300);}},i*stageDelay);});obs.unobserve(pipeline);}},{threshold:isMobile?0.05:0.15});obs.observe(pipeline);})();
(function(){var track=document.getElementById('tlTrack');if(!track)return;var fill=document.getElementById('tlLineFill');var dots=[document.getElementById('tlDot1'),document.getElementById('tlDot2'),document.getElementById('tlDot3'),document.getElementById('tlDot4')];var cards=[document.getElementById('tlCard1'),document.getElementById('tlCard2'),document.getElementById('tlCard3'),document.getElementById('tlCard4')];var isMobile=window.innerWidth<=768;var cardDelay=isMobile?500:700;var activated=false;var obs=new IntersectionObserver(function(entries){if(entries[0].isIntersecting&&!activated){activated=true;fill.style.height='100%';dots.forEach(function(dot,i){setTimeout(function(){if(dot) dot.classList.add('lit');if(cards[i]){cards[i].classList.add('active');cards[i].style.opacity='1';cards[i].style.transform='none';}},300+i*cardDelay);});obs.unobserve(track);}},{threshold:isMobile?0.05:0.1});cards.forEach(function(c){if(c){c.style.opacity='0';c.style.transform='translateY(20px)';c.style.transition='all .6s cubic-bezier(.16,1,.3,1)';}});obs.observe(track);})();
(function(){var grid=document.getElementById('pressureGrid');if(!grid)return;var activated=false;var circ=2*Math.PI*56;var obs=new IntersectionObserver(function(entries){if(entries[0].isIntersecting&&!activated){activated=true;var g1=document.getElementById('g1');var g2=document.getElementById('g2');if(g1) g1.style.strokeDashoffset=circ*(1-0.88);if(g2) g2.style.strokeDashoffset=circ*(1-0.46);var m1=document.getElementById('m1');var m2=document.getElementById('m2');var m7=document.getElementById('m7');if(m1) m1.style.width='88%';if(m2) m2.style.width='95%';if(m7) m7.style.width='46%';obs.unobserve(grid);}},{threshold:0.15});obs.observe(grid);})();
(function(){var bar=document.getElementById('mobileCartBar');if(!bar||window.innerWidth>768)return;bar.style.transform='translateY(100%)';bar.style.transition='transform .4s cubic-bezier(.16,1,.3,1)';var shown=false;var heroObs=new IntersectionObserver(function(entries){if(!entries[0].isIntersecting&&!shown){shown=true;bar.style.transform='translateY(0)';}else if(entries[0].isIntersecting&&shown){shown=false;bar.style.transform='translateY(100%)';}},{threshold:0});var hero=document.querySelector('.hero-grid');if(hero) heroObs.observe(hero);})();
document.querySelectorAll('a[href^="#"]').forEach(function(a){a.addEventListener('click',function(e){var id=this.getAttribute('href');if(id&&id.length>1){var el=document.querySelector(id);if(el){e.preventDefault();var offset=window.innerWidth<=768?60:70;var top=el.getBoundingClientRect().top+window.pageYOffset-offset;window.scrollTo({top:top,behavior:'smooth'});}}});});
function toggleMobileNav(){var o=document.getElementById('mobOverlay'),m=document.getElementById('mobMenu');if(o&&m){o.classList.toggle('open');m.classList.toggle('open');document.body.style.overflow=m.classList.contains('open')?'hidden':''}}

function swapHeroImg(el, src){

  const main = document.querySelector(".hero-main-img img");

  if(main){
    main.src = src;
  }

  document.querySelectorAll(".hero-thumb").forEach(t=>{
    t.classList.remove("active");
  });

  el.classList.add("active");

}



// custom add to cart starts here


function addToCartCustom(btn){

  /* GET VARIANT ID FROM BUTTON */

  let variantId = btn.dataset.id;

  if(!variantId){
    console.error("Variant ID missing");
    return;
  }

  console.log("Variant ID:", variantId);

  /* SHOW LOADER */

  btn.classList.add("loading");

  fetch('/cart/add.js', {
    method:'POST',
    headers:{
      'Content-Type':'application/json'
    },
    body:JSON.stringify({
      id: variantId,
      quantity: 1
    })
  })
  .then(res=>res.json())
  .then(()=>{

    return fetch('/?sections=cart-drawer,cart-icon-bubble');

  })
  .then(res => res.json())
  .then(data => {

    const parser = new DOMParser();

    /* UPDATE CART DRAWER */

    const drawerHTML = parser.parseFromString(data["cart-drawer"], "text/html");
    const newDrawer = drawerHTML.querySelector("cart-drawer");
    const currentDrawer = document.querySelector("cart-drawer");

    if (!newDrawer || !currentDrawer) {
      console.error("Cart drawer not found");
      return;
    }

    currentDrawer.innerHTML = newDrawer.innerHTML;

    /* FIX EMPTY STATE */

    currentDrawer.classList.remove("is-empty");

    /* UPDATE CART ICON */

    const bubbleHTML = parser.parseFromString(data["cart-icon-bubble"], "text/html");
    const newBubble = bubbleHTML.querySelector("#cart-icon-bubble");
    const currentBubble = document.querySelector("#cart-icon-bubble");

    if (newBubble && currentBubble) {
      currentBubble.innerHTML = newBubble.innerHTML;
    }

    /* OPEN CART DRAWER */

    if (typeof currentDrawer.open === "function") {
      currentDrawer.open();
    } else {
      currentDrawer.classList.add("active");
      document.body.classList.add("overflow-hidden");
    }

    /* REMOVE LOADER */

   btn.classList.remove("loading");

  })
  .catch(err=>{
    console.error("Add to cart failed:", err);
  });

}

// custom add to cart ends here

  document.addEventListener("DOMContentLoaded", initFAQ);
document.addEventListener("shopify:section:load", initFAQ); // for editor

function initFAQ() {
  console.log("FAQ Init Running...");

  document.querySelectorAll('.faq-item').forEach(item => {

    const btn = item.querySelector('.faq-btn');
    const body = item.querySelector('.faq-body');

    if (!btn || btn.dataset.customBound === "true") return;

    // mark as initialized (prevents duplicate binding)
    btn.dataset.customBound = "true";

    // REMOVE Dawn/default event by cloning
    const newBtn = btn.cloneNode(true);
    btn.parentNode.replaceChild(newBtn, btn);

    newBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      const isOpen = item.classList.contains('open');

      if (isOpen) {
        item.classList.remove('open');
        body.classList.remove('faq-item-open');
        body.style.maxHeight = null;
      } else {
        item.classList.add('open');
        body.classList.add('faq-item-open');
        body.style.maxHeight = body.scrollHeight + "px";
      }

    });

  });
}



